export const selectUserTeamIds = (selectedIds, optionIds) => {
  const teamIds = [];
  const userIds = [];
  for (const value of selectedIds) {
    if (optionIds.users.includes(value)) {
      userIds.push(value);
    } else if (optionIds.teams.includes(value)) {
      teamIds.push(value);
    }
  }
  return {
    teams: teamIds,
    users: userIds
  };
};